import Swiper, { Navigation, Pagination } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination
    ]);
    new Swiper('.js-more-to-explore', {
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 1.7,
        centeredSlides: false,
        loop: false,
        spaceBetween: 15,
        breakpoints: {
            1024: {
                // 2.9 and 20 are mirrored in the _more-to-explore.scss file into &-slide {}
                // to avoid layout shifts. So if slidesPerView or spaceBetween changes here,
                // it should also change there.
                slidesPerView: 2.9,
                spaceBetween: 20
            }
        }
    });
};
